import { InjectionToken } from '@angular/core';
import type { ApplePayConfig } from './apple-pay.interface';

export const APPLE_PAY_CONFIG = new InjectionToken<ApplePayConfig>(
  'ApplePayConfig',
);
